//=================================================================================================================
//REFERENCIA GENERAL DE LOS COLORES DE LOS DEPÓSITOS EN VISTAS DE BARRIDOS - DEPOSITOS - SUPERVISION Y SEGURIDAD 
//=================================================================================================================

const WAREHOUSE_REFERENCE_COLORS: Record<string, string> = {
  ARROYITO: "#1677ff",
  LOGINTER: "#13c2c2",
  CAROYA: "#52c41a",
  PANAMERICANA: "#fa8c16",
  PARAMERICANA: "#fa8c16",
  SALTO: "#eb2f96",
  TEST: "#722ed1",
};

const FALLBACK_WAREHOUSE_COLOR = "#595959";

export const getWarehouseReferenceColor = (warehouseName?: string): string => {
  if (!warehouseName) {
    return FALLBACK_WAREHOUSE_COLOR;
  }

  const normalizedName = warehouseName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toUpperCase();

  return WAREHOUSE_REFERENCE_COLORS[normalizedName] || FALLBACK_WAREHOUSE_COLOR;
};

export default WAREHOUSE_REFERENCE_COLORS;